export default {
   name: 'share',
   props: {
        url: {
            type: String,
            default: ''
        }
   }
}
